var generateStyle = function generateStyle(componentTheme) {
  return {
    legendRect: {
      backgroundColor: componentTheme.legendRectFillColor
    },
    legendContainer: {
      display: 'inline-flex',
      columnGap: '10px',
      padding: "".concat(componentTheme.legendPadding, " 0")
    },
    headingContainer: {
      margin: "".concat(componentTheme.legendMargin, " 0")
    },
    chartLabel: {
      textAlign: 'center'
    }
  };
};
export default generateStyle;